import { render, staticRenderFns } from "./block-lists.vue?vue&type=template&id=dac4d1b6&"
import script from "./block-lists.vue?vue&type=script&lang=js&"
export * from "./block-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports